import { IDepartmentList } from '@umu/umu-types';
import { getData } from '@umu/umu-util';
import { $window } from '@umu/umu-dom';
import { confirmUserRole } from '../../@utils/userRole';

const shrinkTextWithEllipsis = (text: string): string => {
    return text.substring(0, 4) + '...';
}

const MAX_LEN: number = 30;
export function formatDepartmentName(
    isSample: boolean,
    eName: string,
    departmentName: string,
    id: string,
    parentDepartment: IDepartmentList[] = [],
): string {
    const names: string[] = [eName, ...parentDepartment.map(item => item.department_name)];

    if (departmentName && String(id) !== '0') {
        names.push(departmentName);
    }

    let retStr = names.join('/');

    if (isSample) {
        if (retStr.length > MAX_LEN) {
            names[0] = shrinkTextWithEllipsis(eName);
            retStr = names.join('/');

            if (retStr.length > MAX_LEN) {
                let lastDepartmentName = '';
                if (parentDepartment.length > 0) {
                   lastDepartmentName = parentDepartment[parentDepartment.length - 1].department_name || '';
                }

                if (lastDepartmentName) {
                    lastDepartmentName = shrinkTextWithEllipsis(lastDepartmentName) + '/';
                }

                const emptyHolderStr = new Array(Math.max(0, parentDepartment.length - 1)).fill('.../').join('');
                retStr = shrinkTextWithEllipsis(eName) + '/' + emptyHolderStr + lastDepartmentName + departmentName;
            }
        }
    }

    return retStr;
}

const onGetRole = () => {
    return confirmUserRole();
};

export const role = onGetRole();

export const onDisablePermissionSwitch = (oriData: any) => {
    // 先通过角色判断，如果是系统管理员，可以选择任意部门
    if (role.isAdmin) {
        return false;
    }
    // 如果是学习负责人
    if (role.isManage) {
        // 如果后台开启了 允许向企业内任意部门分配学习任务, 可以选择任意部门
        const enable_assign_task_for_any_department = getData(($window.pageData as any), 'enterprise_setting', 'enable_assign_task_for_any_department');
        if (enable_assign_task_for_any_department) {
            return false;
        }
    }
    if (oriData) {
        // 子管理员根据 is_in_sub_admin_scope 判断
        if (oriData.is_in_sub_admin_scope !== undefined) {
            return !oriData.is_in_sub_admin_scope
        }
        // 其他角色根据 manage_permission 判断
        if (oriData.manage_permission !== undefined) {
            return !oriData.manage_permission
        }
    }
    return false
};
